import React, { useContext, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Slider from "react-slick";
import { ApiContext } from '../../../UseContext/ApiCall';
import { AwsFileUrl, BASE_URL_STATIC } from '../../../../../config';


const CnpPhotoVideoPopup = () => {

  const {
    loggedInUser,

    setShowCreateNewPostPopup,
    setCnpPreviouslyOpenedPopup,
    createNewPost,

    // ----- Create New Post > Text -----
    cnpText, setCnpText,

    // ----- Camera -----
    setShowCnpCameraPopup,
    
    // ----- Photo/Video -----
    showCnpPhotoVideoPopup, setShowCnpPhotoVideoPopup,
    cnpSelectedPhotoVideo, setCnpSelectedPhotoVideo,
    cnpCarouselGrid, setCnpCarouselGrid,
    getVideoDuration,
    
    // ----- Felling/Activity -----
    setShowCnpFeelingActivityPopup,
    setCnpFeelingActivityTab,
    cnpSelectedFeeling,
    cnpSelectedActivityCategory,
    cnpSelectedActivity,
    getActivities,
    getFeelings,
    
    // ----- Check in/Location -----
    cnpSelectedLocation, setCnpSelectedLocation,
    setShowCnpLocationPopup,
    
    
    // ----- Music -----
    setShowCnpSelectMusicPopup,
    cnpSelectedMusic, setCnpSelectedMusic,
    selectedMusicPlaying, setSelectedMusicPlaying,
    cnpMusics,
    getMusics,

    // ----- Tag -----
    setCnpTagAxis,
    showCnpTagsOnPhoto, setShowCnpTagsOnPhoto,
    setShowCnpTagPopup,
    handleRemoveTaggedUser,

    // ----- Text & Background -----
    cnpSelectedTextBackground,

    // ----- Advance Setting -----
    setShowCnpAdvanceSettingPopup,
    getCnpAdvanceSetting,

  } = useContext(ApiContext);

  
  // ----- Camera -----

  // handle click camera
  const handleClickCamera = () => {
    setShowCnpPhotoVideoPopup(false);
    setShowCnpCameraPopup(true);
  };


  // ----- Photo/Video -----

  const [isVideoMuted, setIsVideoMuted] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);


  const photoVideoRef = useRef(null);

  // handle click photo/video
  const handleClickPhotoVideo = () => {
    photoVideoRef.current.click(); 
  };

  // handle file change
  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files);
  
    if (files.length === 0) return;
  
    const validFiles = [];
  
    for (const file of files) {
      // Check file size (1MB = 1 * 1024 * 1024 bytes)
      if (file.size > 1 * 1024 * 1024) {
        alert(`File "${file.name}" is larger than 1MB and will not be added.`);
        continue; // skip large files
      }
  
      // If it's a video, check duration
      if (file.type.startsWith('video/')) {
        const duration = await getVideoDuration(file);
        if (duration > 10) {
          alert(`Video "${file.name}" is longer than 10 seconds and will not be added.`);
          continue; // skip long videos
        }
      }
  
      validFiles.push({
        file,
        tags: [],
      });
    }
  
    const allEntries = [...validFiles, ...cnpSelectedPhotoVideo];
  
    // Separate videos and images
    const videos = allEntries.filter(entry => entry.file.type.startsWith('video/'));
  
    // Enforce limits
    if (videos.length > 5) {
      alert("You can select maximum 5 videos.");
      return;
    }
  
    if (allEntries.length > 15) {
      alert("You can select maximum 15 files in total (videos + images).");
      return;
    }
  
    setCnpSelectedPhotoVideo(allEntries);
  };
  
  

  // Automatically start playing video which show in active slide and other pause
  const videoRefs = useRef([]); 

  // Make sure to reset refs
  videoRefs.current = [];

  const addToVideoRefs = (el, index) => {
    if (el) {
      videoRefs.current[index] = el;
    };
  };
  
  // handle click video play/pause
  const handleClickVideoPlayPause = (e) => {
    const video = e.target;

    if (video.paused) {
      video.play();
    } else {
      video.pause();
    };
  };

  // handle click video mute/unmute
  const handleClickVideoMuteUnmute = () => {
    setIsVideoMuted(!isVideoMuted);
  };
  

  // photo/video slider setting
  const photoVideoSetting = {
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    infinite: false,
    dots: true,
    afterChange: (currentIndex) => {
      setActiveIndex(currentIndex);
    },
  };


  // ----- Feeling/Activity -----

  // handle click feeling/activity
  const handleClickFeelingActivity = () => {

    setShowCnpPhotoVideoPopup(false);
    setShowCnpFeelingActivityPopup(true);
    
    if(cnpSelectedActivityCategory._id) {
      setCnpFeelingActivityTab('activity');

      getActivities(cnpSelectedActivityCategory._id, '', 0);
    } else {
      setCnpFeelingActivityTab('feeling');

      getFeelings('', 0);
    };
  };


  // ----- Location -----

  // handle click location
  const handleClickLocation = () => {
    setShowCnpPhotoVideoPopup(false);
    setShowCnpLocationPopup(true);
  };


  // ----- Music -----

  const musicRef = useRef(new Audio());

  // handle click music
  const handleClickMusic = () => {
    setShowCnpPhotoVideoPopup(false);
    setShowCnpSelectMusicPopup(true);

    getMusics('', cnpMusics.length, 10);
  };

  // handle play/pause music
  const handlePlayPauseMusic = () => {
    if (selectedMusicPlaying) {
      musicRef.current.pause();
      setSelectedMusicPlaying(false);
    } else {
      musicRef.current.src = cnpSelectedMusic.audio;
      musicRef.current.play();
      setSelectedMusicPlaying(true);
    };
  };

  // handle remove music
  const handleRemoveMusic = () => {
    setCnpSelectedMusic({});

    musicRef.current.pause();
    
    setSelectedMusicPlaying(false);

    // show location image if location selected when user remove music
    if((cnpSelectedTextBackground === '') && (cnpSelectedLocation.place !== '' && cnpSelectedLocation.lat !== null && cnpSelectedLocation.lng !== null)) {
      setCnpSelectedLocation(preState => ({
        ...preState,
        placeImage: true
      }));
    };
  };


  // ----- text -----

  // handle text change
  const handleTextChange = (e) => {
    const { value } = e.target;

    setCnpText(value);
  };


  // ----- Tag -----

  // handle tag on photo
  const handleTagOnPhoto = (e, index) => {
    setShowCnpTagPopup(true);
  
    const img = e.target;
    const rect = img.getBoundingClientRect();
  
    const percentX = ((e.clientX - rect.left) / rect.width) * 100;
    const percentY = ((e.clientY - rect.top) / rect.height) * 100;
  
    setCnpTagAxis({ index, offsetX: percentX, offsetY: percentY });
  };
  
  // handle click photo tag icon
  const handleClickPhotoTagIcon = () => {
    setShowCnpTagsOnPhoto(!showCnpTagsOnPhoto);
  };

  // handle click video tag icon
  const handleClickVideoTagIcon = (photoVideoIndex) => {
    setCnpTagAxis({
      index: photoVideoIndex,
      offsetX: '',
      offsetY: '',
    });

    setShowCnpTagPopup(true);
  };


  // ----- Options > Delete/Remove -----
 
  // handle click photo delete icon
  const handleClickPhotoVideoDeleteIcon = () => {
    setCnpSelectedPhotoVideo(prevState =>
      prevState.filter((_, index) => index !== activeIndex)
    );
  };


  // ----- Carousel/Grid ----- 

  // handle click carousel
  const handleClickCarousel = () => {
    setCnpCarouselGrid('carousel');
  };

  // handle click grid
  const handleClickGrid = () => {
    if(cnpSelectedPhotoVideo && cnpSelectedPhotoVideo.length > 1) {
      setCnpCarouselGrid('grid');
    } else {
      alert('Select at least 2 photo/video')
    };
  };
  
  


  // handle post photo/video
  const handlePostPhotoVideo = () => {
    createNewPost('photoVideo');
  };

  // handle click advance setting
  const handleClickAdvanceSetting = () => {
    setShowCnpPhotoVideoPopup(false);
    setShowCnpAdvanceSettingPopup(true);
    getCnpAdvanceSetting('photoVideo');
  };

  // handle close photo/video popup
  const handleClosePhotoVideoPopup = () => {
    setShowCnpPhotoVideoPopup(false);
    setShowCreateNewPostPopup(true);
    setCnpPreviouslyOpenedPopup('createNewPost');
  };


  return (
    <>
      <Modal show={showCnpPhotoVideoPopup} onHide={handleClosePhotoVideoPopup} centered backdrop="static" keyboard={false} className="main-modal" >
      {/* <Modal show={true} onHide={handleClosePhotoVideoPopup} centered backdrop="static" keyboard={false} className="main-modal" > */}
        <Modal.Header className='mb-3 pt-0' closeButton>
          <h5 className='flex-grow-1 text-center pt-3 mb-0'>Photo/Video</h5>
        </Modal.Header>

        <Modal.Body className='pt-1'>
          {/* Profile, Name, Feeling, Activity & Check in/Location */}
          <>
            {
              loggedInUser 
              &&
              <div className='d-flex align-items-center gap-3'>
                {/* Profile */}
                <img src={loggedInUser.profileImg && loggedInUser.profileImg.imageId && AwsFileUrl+loggedInUser.profileImg.imageId} className='border rounded-circle' style={{ height: '45px', width: '45px' }} alt='profile' />

                <div>
                  {/* Name, Feeling, Activity & Check in/Location */}
                  <div>
                    {/* Name */}
                    <span className='fs-5'>{loggedInUser.fname} {loggedInUser.lname}</span> {' '}

                    {/* Feeling */}
                    <>
                      {
                        (cnpSelectedFeeling && cnpSelectedFeeling._id)
                        &&
                        <>
                          <span className='text-secondary'>is</span> {' feeling '}
                          {cnpSelectedFeeling.feelingName} {' '}
                          <img src={cnpSelectedFeeling.feelingIcon} style={{ height: '17px', width: '17px' }} alt="icon" />
                          {' '}
                        </>
                      }
                    </>

                    {/* Activity */}
                    <>
                      {
                        (cnpSelectedActivityCategory && cnpSelectedActivityCategory._id)
                        &&
                        (cnpSelectedActivity && cnpSelectedActivity._id)
                        &&
                        <>
                          <span className='text-secondary'>is</span> {' '}
                          {cnpSelectedActivityCategory.activityCategoryName} {' '}
                          <img src={cnpSelectedActivityCategory.activityCategoryIcon} style={{ height: '17px', width: '17px' }} alt="icon" /> {' '}
                          {cnpSelectedActivity.activityName} {' '}
                          <img src={cnpSelectedActivity.activityIcon} style={{ height: '17px', width: '17px' }} alt="icon" /> {' '}
                        </>
                      }
                    </>

                    {/* Check in/Location */}
                    <>
                      {
                        (cnpSelectedLocation.place !== '' && cnpSelectedLocation.lat !== null && cnpSelectedLocation.lng !== null)
                        &&
                        <>
                          <span className='text-secondary'>at</span> {' '}
                          {cnpSelectedLocation.place.split(" ").slice(0, 5).join(" ")}
                          {cnpSelectedLocation.place.split(" ").length > 5 && "..."}
                        </>
                      }
                    </>
                  </div>

                  {/* Add Location */}
                  <>
                    {
                      (cnpSelectedLocation.place === '' && cnpSelectedLocation.lat === null && cnpSelectedLocation.lng === null)
                      &&
                      <div className='cursor-pointer' onClick={handleClickLocation}>
                        <img src={`/images/icons/location-black.svg`} className='me-1' style={{ height: '15px', width: '15px' }} alt="location" />
                        <span>Add Location</span>
                      </div>
                    }
                  </>
                </div>
              </div>
            }
          </>

          {/* Options > Play/Pause, Mute/Unmute & Delete */}
          <div className='d-flex justify-content-end gap-3 my-3'>
            {/* Mute/Unmute */}
            <>
              {
                (cnpSelectedPhotoVideo && cnpSelectedPhotoVideo.length > 0 && cnpSelectedPhotoVideo[activeIndex] && cnpSelectedPhotoVideo[activeIndex].file && cnpSelectedPhotoVideo[activeIndex].file.type.includes('video'))
                &&
                <div className='bg-secondary px-2 pb-1 rounded-circle cursor-pointer shadow-sm' onClick={handleClickVideoMuteUnmute}>
                  <img src={`/images/icons/${isVideoMuted ? 'mute' : 'unmute'}-white.svg`} style={{ height: '17px', width: '17px', cursor: 'pointer' }} alt="tag" />
                </div>
              }
            </>

            {/* Delete */}
            <>
              {
                (cnpCarouselGrid === 'carousel')
                &&
                <div className='bg-secondary px-2 pb-1 rounded-circle cursor-pointer shadow-sm' onClick={handleClickPhotoVideoDeleteIcon}>
                  <img src="/images/icons/delete-white.svg" style={{ height: '17px', width: '17px', cursor: 'pointer' }} alt="tag" />
                </div>
              }
            </>
          </div>

          {/* Camera/Photo/Video > Carousel */}
          <>
            {
              (cnpCarouselGrid === 'carousel' && cnpSelectedPhotoVideo && cnpSelectedPhotoVideo.length > 0)
              &&
              <Slider className='cnp-photoVideo-slider border my-3' {...photoVideoSetting}>              
                {
                  cnpSelectedPhotoVideo.map((value, index) => (
                    <div className='text-center position-relative' key={index}>

                      {/* Photo */}
                      <>
                        {
                          (value.file && value.file.name && value.file.type.includes('image'))
                          &&
                          <>
                            <img src={URL.createObjectURL(value.file)} className='border' onClick={(e) => handleTagOnPhoto(e, index)} alt="photoVideo" />

                            {/* Tags */}
                            <>
                              {
                                (showCnpTagsOnPhoto && value.tags && value.tags.length > 0)
                                &&
                                value.tags.map((tagValue, tagIndex) => (
                                  <div className='position-absolute pt-1 px-2 bg-secondary rounded-2 d-flex align-items-center gap-2 text-white' key={tagIndex}
                                    style={{ 
                                      top: `${tagValue.offsetY}%`, 
                                      left: `${tagValue.offsetX}%`, 
                                      zIndex: `${tagIndex}`,
                                      fontSize: '13px',
                                      transform: 'translate(-50%, -0%)'
                                    }} 
                                  >
                                    <span>{tagValue.userName}</span>
                                    <span className='cursor-pointer' onClick={() => handleRemoveTaggedUser(index, tagIndex)}>✖</span>
                                  </div>
                                ))
                              }
                            </>

                            {/* Tag Icon */}
                            <div className='position-absolute start-0 bottom-0 ms-2 mb-2 bg-secondary px-2 pb-1 rounded-circle cursor-pointer shadow-sm' onClick={handleClickPhotoTagIcon}>
                              <img src="/images/icons/user-white.svg" style={{ height: '15px', width: '15px', cursor: 'pointer' }} alt="tag" />
                            </div>
                          </>
                        }
                      </>

                      {/* Video */}
                      <>
                        {
                          value.file && value.file.type.includes('video')
                          &&
                          <>
                            <video 
                              src={URL.createObjectURL(value.file)} 
                              ref={(el) => addToVideoRefs(el, index)} 
                              onClick={handleClickVideoPlayPause} 
                              muted={isVideoMuted} 
                              loop 
                            />

                            {/* Tag Icon */}
                            <div className='position-absolute start-0 bottom-0 ms-2 mb-2 bg-secondary px-2 pb-1 rounded-circle cursor-pointer shadow-sm' onClick={() => handleClickVideoTagIcon(index)}>
                              <img src="/images/icons/user-white.svg" style={{ height: '15px', width: '15px', cursor: 'pointer' }} alt="tag" />
                            </div>
                          </>
                        }
                      </>

                    </div>
                  ))
                }
              </Slider>              
            }
          </>

          {/* Camera/Photo/Video > Grid (2) */}
          <>
            {
              (cnpCarouselGrid === 'grid' && cnpSelectedPhotoVideo && cnpSelectedPhotoVideo.length === 2)
              &&
              <div className='border my-3 bg-light d-flex align-items-center justify-content-center' style={{ height: '200px' }}>
                <div style={{ height: '200px' }}>
                  {
                    (cnpSelectedPhotoVideo[0].file.type.includes('image'))
                    ?
                    <img src={URL.createObjectURL(cnpSelectedPhotoVideo[0].file)} className='border object-fit-cover' style={{ height: '200px', width: '100px' }} alt="photoVideo" />
                    :
                    <video src={URL.createObjectURL(cnpSelectedPhotoVideo[0].file)} className='border rounded-0 object-fit-cover' style={{ height: '200px', width: '100px' }} ></video>
                  }
                </div>

                <div style={{ height: '200px' }}>
                  {
                    (cnpSelectedPhotoVideo[1].file.type.includes('image'))
                    ?
                    <img src={URL.createObjectURL(cnpSelectedPhotoVideo[1].file)} className='border object-fit-cover' style={{ height: '200px', width: '100px' }} alt="photoVideo" />
                    :
                    <video src={URL.createObjectURL(cnpSelectedPhotoVideo[1].file)} className='border rounded-0 object-fit-cover' style={{ height: '200px', width: '100px' }} ></video>
                  }
                </div>
              </div>
            }
          </>

          {/* Camera/Photo/Video > Grid (3) */}
          <>
            {
              (cnpCarouselGrid === 'grid' && cnpSelectedPhotoVideo && cnpSelectedPhotoVideo.length === 3)
              &&
              <div className='border my-3 bg-light d-flex align-items-center justify-content-center' style={{ height: '200px' }}>
                <div style={{ height: '200px' }}>
                  {
                    (cnpSelectedPhotoVideo[0].file.type.includes('image'))
                    ?
                    <img src={URL.createObjectURL(cnpSelectedPhotoVideo[0].file)} className='border object-fit-cover' style={{ height: '200px', width: '100px' }} alt="photoVideo" />
                    :
                    <video src={URL.createObjectURL(cnpSelectedPhotoVideo[0].file)} className='border rounded-0 object-fit-cover' style={{ height: '200px', width: '100px' }} ></video>
                  }
                </div>

                <div className='d-flex flex-column'>
                  <div style={{ height: '100px' }}>
                    {
                      (cnpSelectedPhotoVideo[1].file.type.includes('image'))
                      ?
                      <img src={URL.createObjectURL(cnpSelectedPhotoVideo[1].file)} className='border object-fit-cover' style={{ height: '100px', width: '100px' }} alt="photoVideo" />
                      :
                      <video src={URL.createObjectURL(cnpSelectedPhotoVideo[1].file)} className='border rounded-0 object-fit-cover' style={{ height: '100px', width: '100px' }} ></video>
                    }
                  </div>

                  <div style={{ height: '100px' }}>
                    {
                      (cnpSelectedPhotoVideo[2].file.type.includes('image'))
                      ?
                      <img src={URL.createObjectURL(cnpSelectedPhotoVideo[2].file)} className='border object-fit-cover' style={{ height: '100px', width: '100px' }} alt="photoVideo" />
                      :
                      <video src={URL.createObjectURL(cnpSelectedPhotoVideo[2].file)} className='border rounded-0 object-fit-cover' style={{ height: '100px', width: '100px' }} ></video>
                    }
                  </div>
                </div>
              </div>
            }
          </>

          {/* Camera/Photo/Video > Grid (4 or more) */}
          <>
            {
              (cnpCarouselGrid === 'grid' && cnpSelectedPhotoVideo && cnpSelectedPhotoVideo.length >= 4)
              &&
              <div className='border my-3 bg-light d-flex align-items-center justify-content-center' style={{ height: '200px' }}>
                <div className='d-flex flex-column'>
                  <div style={{ height: '100px' }}>
                    {
                      (cnpSelectedPhotoVideo[0].file.type.includes('image'))
                      ?
                      <img src={URL.createObjectURL(cnpSelectedPhotoVideo[0].file)} className='border object-fit-cover' style={{ height: '100px', width: '100px' }} alt="photoVideo" />
                      :
                      <video src={URL.createObjectURL(cnpSelectedPhotoVideo[0].file)} className='border rounded-0 object-fit-cover' style={{ height: '100px', width: '100px' }} ></video>
                    }
                  </div>

                  <div style={{ height: '100px' }}>
                    {
                      (cnpSelectedPhotoVideo[1].file.type.includes('image'))
                      ?
                      <img src={URL.createObjectURL(cnpSelectedPhotoVideo[1].file)} className='border object-fit-cover' style={{ height: '100px', width: '100px' }} alt="photoVideo" />
                      :
                      <video src={URL.createObjectURL(cnpSelectedPhotoVideo[1].file)} className='border rounded-0 object-fit-cover' style={{ height: '100px', width: '100px' }} ></video>
                    }
                  </div>
                </div>

                <div className='d-flex flex-column'>
                  <div style={{ height: '100px' }}>
                    {
                      (cnpSelectedPhotoVideo[2].file.type.includes('image'))
                      ?
                      <img src={URL.createObjectURL(cnpSelectedPhotoVideo[2].file)} className='border object-fit-cover' style={{ height: '100px', width: '100px' }} alt="photoVideo" />
                      :
                      <video src={URL.createObjectURL(cnpSelectedPhotoVideo[2].file)} className='border rounded-0 object-fit-cover' style={{ height: '100px', width: '100px' }} ></video>
                    }
                  </div>

                  <div className={`${cnpSelectedPhotoVideo.length > 4 ? 'position-relative' : ''}`} style={{ height: '100px' }}>
                    {
                      (cnpSelectedPhotoVideo[3].file.type.includes('image'))
                      ?
                      <img src={URL.createObjectURL(cnpSelectedPhotoVideo[3].file)} className='border object-fit-cover' style={{ height: '100px', width: '100px' }} alt="photoVideo" />
                      :
                      <video src={URL.createObjectURL(cnpSelectedPhotoVideo[3].file)} className='border rounded-0 object-fit-cover' style={{ height: '100px', width: '100px' }} ></video>
                    }

                    <>
                      {
                        (cnpSelectedPhotoVideo.length > 4)
                        &&
                        <span className='position-absolute top-50 start-50 translate-middle h-100 w-100 d-flex align-items-center justify-content-center text-white' 
                          style={{ fontSize: '30px', backgroundColor: '#80808080' }}
                        >+{cnpSelectedPhotoVideo.length-4}</span>
                      }
                    </>
                  </div>
                </div>
              </div>
            }
          </>


          {/* Click here to add photo/video */}
          <>
            {
              (cnpSelectedPhotoVideo && cnpSelectedPhotoVideo.length === 0)
              &&
              <div className='border rounded-4 my-3 d-flex flex-column align-items-center justify-content-center gap-2 cursor-pointer' style={{ height: '200px' }} onClick={handleClickPhotoVideo} >
                <img src="/images/icons/add-gallary.svg" style={{ height: '75px', width: '75px' }} alt="addGallary" />

                <span className='text-secondary'>Click here to add photo/video</span>
              </div>
            }
          </>

          {/* Music text (jb music selected h lekin music image show nhi krna h tb ye show krna h) */}
          <>
            {
              (cnpSelectedMusic && cnpSelectedMusic.id && cnpSelectedMusic.id !== '')
              &&
              <div className='my-3 d-flex align-items-center gap-3'>
                <img src="/images/icons/music.svg" style={{ height: '17px', width: '17px' }} alt="music" />

                <span className='me-auto text-truncate'>{cnpSelectedMusic.name}</span>

                {/* Play/Pause */}
                <img src={selectedMusicPlaying ? "/images/icons/pause-circle.svg" : "/images/icons/play-circle.svg"} 
                  className='cursor-pointer' style={{ height: '25px', width: '25px' }} onClick={handlePlayPauseMusic} alt='playPause'
                />

                {/* Remove */}
                <img src="/images/icons/close-circle.svg" className='cursor-pointer' style={{ height: '25px', width: '25px' }} onClick={handleRemoveMusic} alt="remove" />
              </div>
            }
          </>

          {/* Carousel/Grid */}
          <div className='border d-flex align-items-center'>
            {/* Carousel */}
            <div className={`${cnpCarouselGrid === 'carousel' ? 'bg-primary text-white' : ''} d-flex align-items-center justify-content-center flex-grow-1 gap-2 py-1 cursor-pointer`}
              onClick={handleClickCarousel}
            >
              <img src={`/images/icons/carousel-${cnpCarouselGrid === 'carousel' ? 'white' : 'black'}.svg`} style={{ height: '20px', width: '20px' }} alt="carousel" />
              <span>Carousel</span>
            </div>

            {/* Grid */}
            <div className={`${cnpCarouselGrid === 'grid' ? 'bg-primary text-white' : ''} d-flex align-items-center justify-content-center flex-grow-1 gap-2 py-1 cursor-pointer`}
              onClick={handleClickGrid}
            >
              <img src={`/images/icons/grid-plus-${cnpCarouselGrid === 'grid' ? 'white' : 'black'}.svg`} style={{ height: '20px', width: '20px' }} alt="grid-plus" />
              <span>Grid</span>
            </div>
          </div>

          {/* text */}
          <textarea className="form-control rounded-4 my-3 shadow-none" name="text" style={{ resize: 'none' }} rows={3} 
            value={cnpText} onChange={handleTextChange} placeholder={`What's new ${loggedInUser && loggedInUser.fname}..?`}
          />

          {/* Menu */}
          <div className='d-flex flex-wrap gap-4'>
            <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickCamera}>
              <img src={`${BASE_URL_STATIC}/create-icon2.png`} style={{ height: '23px', width: '23px' }} alt="Camera" />
              <small className="text-secondary">Camera</small>
            </div>

            <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickPhotoVideo}>
              <img src={`${BASE_URL_STATIC}/create-icon3.png`} style={{ height: '23px', width: '23px' }} alt="post" />
              <small className="text-secondary">Photo/Video</small>
              <input type="file" ref={photoVideoRef} style={{ display: 'none' }} accept="image/*,video/*" onChange={handleFileChange} multiple />
            </div>

            <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickFeelingActivity}>
              <img src={`${BASE_URL_STATIC}/create-icon8.png`} style={{ height: '23px', width: '23px' }} alt="feeling/activity" />
              <small className="text-secondary">Feeling/Activity</small>
            </div>

            <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickLocation}>
              <img src={`${BASE_URL_STATIC}/create-icon9.png`} style={{ height: '23px', width: '23px' }} alt="Check In" />
              <small className="text-secondary">Check In</small>
            </div>

            <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickMusic}>
              <img src={`${BASE_URL_STATIC}/create-icon11.png`} style={{ height: '23px', width: '23px' }} alt="Music" />
              <small className="text-secondary">Music</small>
            </div>
          </div>
          
          <button type="button" className='btn btn-primary w-100 rounded-pill mt-3 mb-1' onClick={handlePostPhotoVideo}
            disabled={cnpSelectedPhotoVideo && cnpSelectedPhotoVideo.length === 0}
          >Post</button>

          {/* Advance Setting */}
          <div className='text-center'>
            <span className='text-primary cursor-pointer' onClick={handleClickAdvanceSetting}>Advance Setting</span>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default CnpPhotoVideoPopup